<div class="flex p-4 pt-14">
  <div class="flex-1 flex flex-col items-center mx-auto my-auto">
    <div class="flex w-full items-center justify-center mb-12">
      <img src="images/logo/logo.png" alt="Logo" width="58" height="58" />
    </div>
    <div class="bg-shikenso-base-white px-14 py-10 rounded-2xl max-w-[480px]">
      <div class="flex flex-col items-center justify-center gap-2 mb-6 px-6">
        <h1 class="text-[28px] font-bold text-black">{{ 'pages.changePassword.title' | translate }}</h1>
        <p class="text-shikenso-gray-700 text-sm text-center">{{ 'pages.changePassword.description' | translate }}</p>
      </div>

      <form [formGroup]="passwordForm" class="custom-form flex flex-col gap-2" (ngSubmit)="onSubmit()">
        <!-- Current password -->
        <mat-form-field class="w-full mb-3">
          <mat-label>{{ 'pages.changePassword.currentPassword' | translate }}</mat-label>
          <input matInput formControlName="currentPassword" [type]="showCurrentPassword() ? 'text' : 'password'" />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="!bg-transparent mat-big-icon-button"
            (click)="showCurrentPassword.set(!showCurrentPassword())"
          >
            @if (showCurrentPassword()) {
              <app-icon src="/icons/view-off.svg" alt="View off" />
            } @else {
              <app-icon src="/icons/view.svg" alt="View" />
            }
          </button>
          <mat-error [control]="passwordForm.get('currentPassword')" />
        </mat-form-field>

        <!-- New password -->
        <mat-form-field class="w-full">
          <mat-label>{{ 'pages.changePassword.newPassword' | translate }}</mat-label>
          <input matInput formControlName="newPassword" [type]="showNewPassword() ? 'text' : 'password'" />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="!bg-transparent mat-big-icon-button"
            (click)="showNewPassword.set(!showNewPassword())"
          >
            @if (showNewPassword()) {
              <app-icon src="/icons/view-off.svg" alt="View off" />
            } @else {
              <app-icon src="/icons/view.svg" alt="View" />
            }
          </button>
          <mat-error [control]="passwordForm.get('newPassword')" />
        </mat-form-field>

        <!-- Confirm new password -->
        <mat-form-field class="w-full">
          <mat-label>{{ 'pages.changePassword.confirmNewPassword' | translate }}</mat-label>
          <input
            matInput
            formControlName="confirmNewPassword"
            [type]="showConfirmNewPassword() ? 'text' : 'password'"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="!bg-transparent mat-big-icon-button"
            (click)="showConfirmNewPassword.set(!showConfirmNewPassword())"
          >
            @if (showConfirmNewPassword()) {
              <app-icon src="/icons/view-off.svg" alt="View off" />
            } @else {
              <app-icon src="/icons/view.svg" alt="View" />
            }
          </button>
          <mat-error [control]="passwordForm.get('confirmNewPassword')" />
        </mat-form-field>

        <!-- Buttons -->
        <div class="flex items-center justify-center mt-3">
          <button mat-flat-button type="submit" class="w-full" [disabled]="loading()">
            @if (loading()) {
              <app-dots-spinner />
            } @else {
              {{ 'pages.changePassword.changePassword' | translate }}
            }
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
